import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import _ from 'underscore'

import ListSelector from 'components/ListSelectAndSort'
import Search from 'components/Search'

import { searchAlertDescriptions } from 'pages/AlertLookup/search'

import { useStoreContext } from 'hooks/StoreContext'
import useAlertDescriptions from 'hooks/useAlertDescriptions'

import { screenSize } from 'styles/shared'
import FormSection from '../FormSection'

type Alerts = {
  id: string | undefined
  title: string | undefined
  code: string | undefined
}

type Props ={
  TrendAlerts: Alerts[]
  onAlertListChangeCallback: (alerts)=> void
}

const TrendAlerts = ({ TrendAlerts, onAlertListChangeCallback }: Props) => {
  useAlertDescriptions()
  const { alertDescriptions } = useStoreContext()

  const [search, setSearch] = useState('')
  const [availableAlerts, setAvailableAlerts] = useState<Array<Alerts>>([])
  const [selectedAlerts, setSelectedAlerts] = useState<Array<Alerts>>([])

  useEffect(() => {
    if (TrendAlerts) {
      setSelectedAlerts(TrendAlerts)
    }

    if (selectedAlerts) {
      const selectedIds = _.pluck(selectedAlerts, 'id')
      const alertList = selectedIds ? _.filter(availableAlerts, alert => !_.includes(selectedIds, alert.id)) : availableAlerts

      setAvailableAlerts(alertList)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [TrendAlerts, selectedAlerts])

  const handleSearch = (query) => {
    const filteredAlerts = query && searchAlertDescriptions(query, alertDescriptions)
    const alertListItems = filteredAlerts && filteredAlerts.map((item) => ({ id: item.code, code: item.code, title: item.code }))

    const selectedIds = _.pluck(selectedAlerts, 'id')
    const alertList = selectedIds ? _.filter(alertListItems, alert => !_.includes(selectedIds, alert.id)) : availableAlerts

    setAvailableAlerts(alertList || [])
  }

  const handleAlertListChange = (selected, available) => {
    setSelectedAlerts(selected)
    setAvailableAlerts(available)
    onAlertListChangeCallback(selected)
  }

  return (
    <FormSection title="Select Alerts">
      <S.SearchContainer>
        <Search
          value={search}
          noForm
          placeholder="Search by alert code or description"
          ariaLabel="alert codes"
          onChange={setSearch}
          onSearch={(query) => handleSearch(query)}
          variant="text"
        />
      </S.SearchContainer>

      <ListSelector
        subTitle="Add Alerts"
        selectedListLabel="Selected Alerts"
        availableListLabel="Available Alerts"
        initialSelected={selectedAlerts}
        initialAvailable={availableAlerts}
        onChangeCallback={handleAlertListChange}
      />
    </FormSection>
  )
}

export default TrendAlerts

const S = {
  SearchContainer: styled.div`
    width: 395px;
    margin: 15px 0;

    @media ${screenSize.small} {
      display: block;
      width: 100%;
    }
  `
}
